import React from 'react';
import { ListGroup, ListGroupItem } from 'reactstrap';
import { Link } from 'react-router-dom';
import { useAllScanTunnelQuery } from '../../graphql/queries/allScanTunnels.generated';
import { MainHeader } from '../../components/Layout/MainHeader';
import { ContentSection } from '../../components/Layout/ContentSection';
import i18n from '@/utils/i18n';
import { useDocumentTitle } from '@/hooks/useDocumentTitle';

export const ScanTunnelsIndexView = () => {
  useDocumentTitle('PageTitles:scanTunnels');

  const { loading, error, data } = useAllScanTunnelQuery();

  if (error) return <div>Error: {error.message}</div>;

  return (
    <div>
      <MainHeader
        title={i18n.t('Common:scanTunnels')}
        rightButton={{
          label: 'Create Scan Tunnel',
          link: '/scan-tunnel/create',
        }}
      />
      <ContentSection title={i18n.t('Common:scanTunnels')} collapsable={false}>
        {loading && <div>Loading...</div>}

        <ListGroup>
          {data?.scanTunnels?.map((scanTunnel) => (
            <ListGroupItem key={scanTunnel.id}>
              <Link to={'/scan-tunnel/' + scanTunnel.id}>
                {scanTunnel.name}
              </Link>
            </ListGroupItem>
          ))}
        </ListGroup>
      </ContentSection>
    </div>
  );
};
